<template>
  <div v-cloak  v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>
      <!--<i class="el-icon-arrow-left"></i>-->
      <!--<span class="title">My To Do List</span>-->
    </div>

    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ path:'/home' }"><i class="fa fa-home"></i> Home</router-link>
        </li>
        <li>
          <small>Access Control</small>
        </li>
        <li class="active">
          <small>Function Mgmt.</small>
        </li>
      </ol>
    </div>
    <confirmation-box ref="deleteDialog" @handleConfirm="handleConfirm"></confirmation-box>
    <add-function ref="addFunction" :parentId="parentId" @saveSuccess="getFunctionList"></add-function>
    <edit-function ref="editFunction" :parentId="parentId" @saveSuccess="getFunctionList" :functionPermissionTreeDTOS="functionPermissionTreeDTOS"></edit-function>


    <div class="tab">
      <el-tabs class="el-tabs" type="border-card">
        <el-tab-pane label="Detail">
          <!--<el-row :gutter="20">-->
            <!--<el-col :span="23">-->
                <!--<div class="text-right">-->
                  <!--<el-button type="primary" @click="handleExportExcel()">Save</el-button>-->
                  <!--<el-button type="warning"  @click="resetFuntion()">Reset</el-button>-->
                <!--</div>-->
            <!--</el-col>-->
          <!--</el-row>-->
          <el-row :gutter="20">
          <el-col :span="12">
            <h5>Function List</h5>
            <div class="area">
              <div class="area-1">
              <el-row :gutter="20">
                <el-col :span="18">
                  <el-form ref="queryForm"  label-width="100px"  label-position="right">
                    <el-form-item  label="功能名称：" ><!--prop校验-->
                      <el-input v-model="searchFunctionValue" size="small" ></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span=6>
                  <div class="text-left button-auto" style="margin-top: 10px;">
                    <el-button type="primary" size="mini" @click="searchForFunctionTree()">Search</el-button>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="23">
                  <div class="text-right button-auto2" style="margin-bottom: 10px;" >
                  <el-button type="primary" size="mini" @click="addFunction()"  :disabled ="addDisabled">Add</el-button>
                  <el-button type="primary" size="mini" @click="editFunction()"  :disabled ="editDisabled">Edit Selected</el-button>
                  <el-button type="primary" size="mini" @click="saveStructure()"  :disabled ="saveDisabled">Save Structure</el-button>
                  <el-button type="danger" size="mini" @click="deleteFunction()"  :disabled ="deleteDisabled">Delete Checked List</el-button>
                  </div>
                </el-col>
              </el-row>
              </div>
              <div class="area-2">
              <el-row :gutter="20">
                <el-col :span="23">
                  <tree-control ref="functionTree" :structure="structure" @nodeClick="nodeClick"></tree-control>
                </el-col>
              </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <h5>API List</h5>
            <div class="area">
              <div class="area-1">
                <el-row :gutter="20">
                  <el-col :span="18">
                    <el-form ref="queryForm"  label-width="100px"  label-position="right">
                      <el-form-item  label="API：" ><!--prop校验-->
                        <el-input v-model="searchApiValue" size="small" ></el-input>
                      </el-form-item>
                    </el-form>
                  </el-col>
                  <el-col :span=6>
                    <div class="text-left button-auto" style="margin-top: 10px;">
                      <el-button type="primary" size="mini" @click="searchForApiTree()">Search</el-button>
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="23">
                    <div class="text-right button-auto2" style="margin-bottom: 10px;" >
                      <el-button type="primary" size="mini" @click="saveFunctionApi()" :disabled="saveApiDisabled">Save Function Api Relationship</el-button>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="area-2">
              <el-row :gutter="20">
                <el-col :span="23">
                  <tree-selection ref="treeSelection" :structure="apiStructure" :showReadWrite="showReadWrite" :showCheckbox="showCheckbox"></tree-selection>
                </el-col>
              </el-row>
              </div>
            </div>
          </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>

</template>

<script>

  import confirmationBox from '@/components/dialog/confirmation_box.vue'
  import treeControl from '@/view/acs/tree/tree_control.vue'
  import treeSelection from '@/view/acs/tree/tree_selection.vue'
  import addFunction from '@/view/acs/function_permission/dialog/add_function.vue'
  import editFunction from '@/view/acs/function_permission/dialog/edit_function.vue'
  import util from '@/util/util.js'
  let Base64 = require('js-base64').Base64
  export default {
    props: {

    },
    components: {
      confirmationBox,
      treeControl,
      treeSelection,
      addFunction,
      editFunction
    },
    data(){
      return{
        dataLoading: false,
        showReadWrite: false,
        showCheckbox: true,
        showFunctionCheckbox: true,
        searchFunctionValue:'',
        searchApiValue: '',
        parentId:'0',
        functionPermissionTreeDTOS: {},
        structure:[
          {
            id: 0,
            name: 'ROOT',
            children:[]
          }
        ],
        clickNode:{},

        apiStructure:[
        ],
        addDisabled:false,
        editDisabled:true,
        saveDisabled:false,
        deleteDisabled:true,
        saveApiDisabled:true,
      }

    },
    computed: {

    },


    created(){
      this.getFunctionList();
      this.getApiList();
    },


    methods: {
        getFunctionList(){
        let url = this.baseAcsUrl + '/acs/function-permission/get-function-tree?app_key=' + this.appKey;
          this.dataLoading = true;
          this.http.get(url).then(resp =>{
            //this.structure = resp.data;
            this.$refs.functionTree.initTree(resp.data, 'functionName');

            // 每次加载，选中的node置空
            this.clickNode ={};
            this.dataLoading = false;
          }).catch(error => {
            this.dataLoading = false;
            console.info(error);
          });
      },
      handleConfirm(){

          console.log(this.clickNode);
        if(!(this.clickNode && this.clickNode.id)){
          this.$message.warning('Select record please');
          return;
        }
        let url = this.baseAcsUrl + '/acs/function-permission/delete-functions';
        this.dataLoading = true;
        this.http.delete(url,[this.clickNode.id]).then(resp =>{
          this.dataLoading = false;
          this.$refs.deleteDialog.hideDialog();
          this.$message.success('Successful operation');
          this.getFunctionList();

        }).catch(error => {
          this.dataLoading = false;
          console.info(error);
        });
      },
      getApiList(){
        let url = this.baseAcsUrl + '/acs/api/get-api-group-by-domain';
        this.dataLoading = true;
        this.http.get(url).then(resp =>{
          this.dataLoading = false;
          this.assemblyApiStructure(resp.data);
          this.clickNode = {};
        }).catch(error => {
          this.dataLoading = false;
          console.info(error);

        });
      },
      assemblyApiStructure(data){
        // data = JSON.parse(JSON.stringify(data).replace(/domain/g,"name"));
        // data = JSON.parse(JSON.stringify(data).replace(/apis/g,"children"));

        data.forEach( service => {
          service.name = service.serviceName;
          service.readChecked = false;
          service.readIndeterminate = false;
          service.writeChecked = false;
          service.writeIndeterminate = false;
          service.children = service.domainApiDTOS;
            if(service.children){
              service.children.forEach(domain =>{
                domain.name = domain.domain;
                service.readChecked = false;
                service.readIndeterminate = false;
                service.writeChecked = false;
                service.writeIndeterminate = false;
                domain.children = domain.apis;
                if(domain.children){
                  domain.children.forEach( apiSuffix => {
                    apiSuffix.name = apiSuffix.description + ' ' + apiSuffix.apiType + "#" + apiSuffix.apiPath;
                    apiSuffix.readChecked = false;
                    apiSuffix.readIndeterminate = false;
                    apiSuffix.writeChecked = false;
                    apiSuffix.writeIndeterminate = false;
                  });
                }
              })
            }
        });

        this.$refs.treeSelection.init(data, 'name', 'readChecked', 'writeChecked');
      },
      searchForFunctionTree(){
        this.$refs.functionTree.filter(this.searchFunctionValue);

      },
      searchForApiTree(){
        this.$refs.treeSelection.filter(this.searchApiValue);
      },
      addFunction(){
        this.parentId = this.$refs.functionTree.getFunctionNodeKey();
        this.$refs.addFunction.showDialog();

      },
      editFunction(){
        this.functionPermissionTreeDTOS = this.$refs.functionTree.getCurrentNode();
        console.log(this.functionPermissionTreeDTOS);
        this.$refs.editFunction.showDialog();
      },
      deleteFunction(){
        this.$refs.deleteDialog.showDialog();
      },
      saveFunctionApi(){
        let url = this.baseAcsUrl + "/acs/function-permission/save-function-apis";
        this.dataLoading = true;
        let selectedNode = this.$refs.functionTree.getCurrentNode();
        let functionId = selectedNode.id;
        let keys = this.$refs.treeSelection.getCheckedKeys();
        let payload = {};
        payload.functionId = functionId;
        payload.apiIds = keys;
        this.http.post(url, [payload]).then(resp =>{
          this.$message.success('Successful operation ');
          this.dataLoading = false;
          console.info(resp.data)
        }).catch(error => {
          this.$message.warning('Operation failure');
          this.dataLoading = false;
          console.info(error);
        });
      },
      encryptData(item){ //先遍历最外层数据，进行加密
        let functionKey = Base64.encode(item.functionKey)
        let functionName = Base64.encode(item.functionName)
        let description,icon,url,children
        if(item.description){
          description = Base64.encode(item.description)
        }
        if(item.icon){
          icon = Base64.encode(item.icon)
        }
        if(item.url){
          url = Base64.encode(item.url)
        }
        if(item.children && item.children.length > 0){ //检测到children有值的时候就再去遍历children加密
          children = this.encryptChildren(item.children)
        }
        let newItem = item
        newItem.functionKey = functionKey
        newItem.functionName = functionName
        newItem.description = description
        newItem.icon = icon
        newItem.url = url
        return newItem
      },
      encryptChildren(children){ //遍历children加密
        children.forEach(item =>{
          let functionKey = Base64.encode(item.functionKey)
          let functionName = Base64.encode(item.functionName)
          let description,icon,url,children
          if(item.description){
            description = Base64.encode(item.description)
          }
          if(item.icon){
            icon = Base64.encode(item.icon)
          }
          if(item.url){
            url = Base64.encode(item.url)
          }
          if(item.children && item.children.length > 0){ //检测到children有值的时候就再去遍历children加密，递归
            children = this.encryptChildren(item.children)
          }
          let newItem = item
          newItem.functionKey = functionKey
          newItem.functionName = functionName
          newItem.description = description
          newItem.icon = icon
          newItem.url = url
          return newItem
        })
      },
      saveStructure(){
        let dataStructure = this.$refs.functionTree.getDataStructure();
        let url = this.baseAcsUrl + '/acs/function-permission/update-functions';
        this.dataLoading = true;
        let newArr = []
        console.info(JSON.stringify(dataStructure));
        dataStructure.forEach(item =>{
          let newItem = this.encryptData(item) //加密数据，为了不让pg网络拦截
          newArr.push(newItem)
        })
        this.http.put(url,newArr).then(resp =>{
          this.$message.success('Successful operation ');
          this.getFunctionList();
          this.dataLoading = false;
        }).catch(error => {
          this.dataLoading = false;
          console.info(error);
          this.$message.warning('Operation failure');
        });
      },
      nodeClick(data){
          console.log(data);
          this.clickNode = data;
          this.editDisabled = (data.id == 0);
          this.deleteDisabled = (data.id ==0);
          this.saveApiDisabled =(data.id ==0);

        let url = this.baseAcsUrl + "/acs/api/get-function-api?function_id=" + data.id;
        this.dataLoading = true;
        this.http.get(url).then(resp =>{
          this.dataLoading = false;
          let apiKeys = [];
          if(resp.data && resp.data.length){
            resp.data.forEach( api => {
              apiKeys.push(api.id);
            });
          }
          this.$refs.treeSelection.setCheckedKeys(apiKeys);
        }).catch(error => {
          this.dataLoading = false;
          console.info(error);
        });
      }

    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
  .area-2{
    height: 688px;
    overflow-y: auto;
  }
  .area {
    margin-top: 10px;
    /*padding: 10px;*/
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    /*background-color: #f6f8f9;*/
    overflow: hidden;
    /*box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);*/
    font-size: 10px;
    height: 800px;
  }
  .area-1 {
    margin-top: 10px;
    margin-bottom: 10px;
    /*padding: 10px;*/
    border-bottom: 1px solid #d1dbe5;
    border-radius: 4px;
    /*background-color: #f6f8f9;*/
    overflow: hidden;
    /*box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);*/
    font-size: 10px;
  }
  .button-auto{

  }
</style>



// WEBPACK FOOTER //
// src/view/acs/function_permission/function_mgmt.vue